import { useTranslation } from "react-i18next";
import { AssessmentCheckboxRadio } from "ui-components";
import "./AdvanceSetting.scss";
interface EngagementType {
  setJobType: any;
  jobType: any;
}
const EngagementType: React.FC<EngagementType> = ({ setJobType, jobType }) => {
  const { t } = useTranslation();
  return (
    <div className="engagementType">
      <span className="comSubLabel">{t("GENERAL.JOB_TYPE")}</span>
      <div className="engagementTypeRow mt-3">
        <div
          className="d-flex engagementTypeCursorPointer rtlGap"
          onClick={() => {
            setJobType((prev: any) => {
              const updatedData = { ...prev, jobType: "onSite" };
              sessionStorage.setItem(
                "advanceSettingData",
                JSON.stringify(updatedData),
              );
              return updatedData;
            });
          }}
        >
          <AssessmentCheckboxRadio
            name="onSite"
            type="radio"
            checked={jobType?.jobType == "onSite"}
            // additionalProps={{ disabled: advanceSettingData?.disable }}
          />
          <p className="radioCheckLabel">{t("CREATE_ASSESSMENT.ONSITE")}</p>
        </div>
        <div
          className="d-flex engagementTypeCursorPointer rtlGap"
          onClick={() => {
            setJobType((prev: any) => {
              const updatedData = { ...prev, jobType: "hybrid" };
              sessionStorage.setItem(
                "advanceSettingData",
                JSON.stringify(updatedData),
              );
              return updatedData;
            });
          }}
        >
          <AssessmentCheckboxRadio
            name="hybrid"
            type="radio"
            checked={jobType?.jobType == "hybrid"}
          />
          <p className="radioCheckLabel">{t("CREATE_ASSESSMENT.HYBRID")}</p>
        </div>
        <div
          className="d-flex engagementTypeCursorPointer rtlGap"
          onClick={() => {
            setJobType((prev: any) => {
              const updatedData = { ...prev, jobType: "remote" };
              sessionStorage.setItem(
                "advanceSettingData",
                JSON.stringify(updatedData),
              );
              return updatedData;
            });
          }}
        >
          <AssessmentCheckboxRadio
            name="remote"
            type="radio"
            checked={jobType?.jobType == "remote"}
          />
          <p className="radioCheckLabel">{t("CREATE_ASSESSMENT.REMOTE")}</p>
        </div>
      </div>
    </div>
  );
};

export default EngagementType;
